/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidlistingdataerror3Inputs */

const en_invalidlistingdataerror3 = /** @type {(inputs: Invalidlistingdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provided listing data is invalid.`)
};

const de_invalidlistingdataerror3 = /** @type {(inputs: Invalidlistingdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Angaben zum Ort sind ungültig.`)
};

/**
* | output |
* | --- |
* | "The provided listing data is invalid." |
*
* @param {Invalidlistingdataerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidlistingdataerror3 = /** @type {((inputs?: Invalidlistingdataerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidlistingdataerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidlistingdataerror3(inputs)
	return de_invalidlistingdataerror3(inputs)
});
export { invalidlistingdataerror3 as "invalidListingDataError" }